<template>
    <div class="form-container">
        <div class="complaint-head">{{$t("nav.AccountComplaint")}}</div>
        <div class="complaint-con">{{$t("complaint.ComplaintCon")}}</div>
    </div>
</template>

<script>
export default {
    data(){
        return {
          
        }
    },
}
</script>

<style  scoped>
    .form-container{
        margin-top: 130px;
        width: 530px;
    }
    .complaint-head{
        color: #2d2d2d;
        font-size: 30px;
        font-weight: bold;
        margin-bottom: 10px
    }
    .complaint-con{
        color: #2d2d2d;
        font-size: 14px;
        line-height: 30px;
    }
</style>
